import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from "react";
import { Button, Flex, Haldor__Block, Icon } from "@haldor/ui";
import DisplayResource from "./DisplayResource";
import DisplayOnlyFeedback from "./DisplayOnlyFeedback";
var AssessmentBlock = /*#__PURE__*/function (_Haldor__Block) {
  function AssessmentBlock(_props) {
    var _this;
    _classCallCheck(this, AssessmentBlock);
    _this = _callSuper(this, AssessmentBlock, [_props]);
    _defineProperty(_this, "editorBlockWasAdded", function () {
      var translate = _this.api.getEditor().getProp("translate");
      _this.events.onTitleChange(translate("Assessment") + " " + (_this.api.getIndex() + 1));
    });
    _defineProperty(_this, "addCoursePart", function (event) {
      event.preventDefault();
      _this.addResource("Haldor.Blocks.AssessmentBlock.ShowModal", {
        visible: true
      });
    });
    _defineProperty(_this, "addGoalMatrix", function (event) {
      event.preventDefault();
      _this.addResource(_this.PART_RESOURCE_TYPE, {
        status: "Started",
        referenceId: "",
        referenceType: "assessmentGoal",
        value: {
          id: 0,
          visibleToStudent: true,
          visibleToGuardian: true,
          title: "",
          rows: []
        },
        permissions: []
      });
    });
    _defineProperty(_this, "addCourses", function (values) {
      values.forEach(function (course) {
        _this.addResource(_this.PART_RESOURCE_TYPE, {
          status: "Started",
          referenceId: "",
          referenceType: "matrix",
          assessmentBlockPartRows: [],
          value: course,
          permissions: []
        });
      });
    });
    _defineProperty(_this, "goalMatrixChange", function (goalMatrix) {
      if (goalMatrix.index != null) {
        var foundExisting = _this.getResources().find(function (resource) {
          return resource.index == goalMatrix.index;
        });
        if (foundExisting != null) {
          var currentIndex = foundExisting.index;
          _this.removeResource(foundExisting);
          _this.addResource(_this.PART_RESOURCE_TYPE, goalMatrix, currentIndex);
          return true;
        }
      }
      _this.addResource(_this.PART_RESOURCE_TYPE, goalMatrix);
    });
    _defineProperty(_this, "courseChange", function (course) {
      if (course == null || course.value == null) {
        return false;
      }
      var foundExisting = _this.getResources().find(function (resource) {
        return resource.value.id == course.value.id;
      });
      if (foundExisting != null) {
        var currentIndex = foundExisting.index;
        _this.removeResource(foundExisting);
        _this.addResource(_this.PART_RESOURCE_TYPE, course, currentIndex);
        return true;
      }
      _this.addResource(_this.PART_RESOURCE_TYPE, course);
    });
    _defineProperty(_this, "edit", function (props) {
      return null;
    });
    _defineProperty(_this, "consume", function (props) {
      var goals = _toConsumableArray(props.resources).filter(function (resource) {
        return resource["@odata.type"] == _this.PART_RESOURCE_TYPE && resource.referenceType == "assessmentGoal";
      });
      var courses = _toConsumableArray(props.resources).filter(function (resource) {
        return resource["@odata.type"] == _this.PART_RESOURCE_TYPE && resource.referenceType == "matrix";
      });
      var feedbackParts = _toConsumableArray(props.resources).filter(function (resource) {
        return resource['@odata.type'] == _this.PART_RESOURCE_TYPE && resource.referenceType == 'assessmentonlyfeedback';
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "block--assessment-block consume"
      }, /*#__PURE__*/React.createElement("div", {
        className: "display-matrix"
      }, goals.map(function (resource) {
        return /*#__PURE__*/React.createElement(DisplayResource, {
          resource: resource,
          block: _this,
          key: resource.id,
          courses: courses
        });
      }), courses.map(function (resource) {
        return /*#__PURE__*/React.createElement(DisplayResource, {
          resource: resource,
          block: _this,
          key: resource.id
        });
      }), feedbackParts.map(function (resource, index) {
        return /*#__PURE__*/React.createElement(DisplayOnlyFeedback, {
          block: _this,
          part: resource
        });
      })));
    });
    _this.name = "Haldor.Blocks.AssessmentBlock";
    _this.block_type = "expandable_block";
    _this.PART_RESOURCE_TYPE = "Haldor.Blocks.AssessmentBlockPart";
    _this.registerResourceType(_this.PART_RESOURCE_TYPE, {
      status: "string",
      referenceId: "string",
      referenceType: "string",
      value: "object"
      // permissions: 'object'
    });
    _this.registerResourceType("Haldor.Blocks.AssessmentBlock.ShowModal", {
      visible: "boolean"
    });
    return _this;
  }
  _inherits(AssessmentBlock, _Haldor__Block);
  return _createClass(AssessmentBlock);
}(Haldor__Block);
export default AssessmentBlock;